import { Eye, UserCheck } from "lucide-react";
import { ContainerCard, EmployeeDetails, ModuleTitleCard } from "../../components/ui/cards";
import { Reactable } from "../../components/ui/reactable";
import { SUBORDINATES_URL } from "../../constants/api";
import { useState } from "react";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const SubordinatesList = () => {

    let navigate = useNavigate();

    // STATES
    const [data, setData] = useState([])
    const [totalRecords, setTotalRecords] = useState(0)

    const columns = [
        {
            accessor: "employee",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            width: "250px",
            Cell: ({ row }) => {
                const record = row;
                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "department",
            Header: "Department",
            filterable: true,
        },
        {
            accessor: "date_of_joining",
            Header: "Date of joining",
            filterable: true,
            filterType: 'date',
            Cell: ({ value }) => {
                if (!value) return "-";

                try {
                    return dayjs(value, "YYYY-MM-DD").format("DD-MM-YYYY");
                } catch (error) {
                    console.error("Date formatting error:", error);
                    return value;
                }
            }
        },
        {
            accessor: "employee_group",
            Header: "Employee Group",
        },
        {
            accessor: "email_id",
            Header: "Email Id",
        },
        {
            accessor: 'actions',
            Header: 'Actions',
            fixed: true,
            align: 'right',
            Cell: ({ row }) => {                
                const handleView = () => {    
                    navigate("/employee/subordinate/viewDetails", {
                        state: {
                            row: row,
                            subordinateId: row.subordinate_id,
                            employeeID: row.employee.id
                        }
                    });
                };

                return (
                    <>
                        <Button
                            variant='ghost'
                            onClick={handleView}
                            className="px-3 py-2 hover:bg-orange-50 dark:hover:bg-orange-900/20"
                            title="View Employee Details"
                        >
                            <Eye className="text-orange-500 h-4 w-4" />
                        </Button>
                    </>
                );
            }
        }
    ]

    return (
        <ContainerCard>
            {/* title */}
            <ModuleTitleCard Icon={UserCheck} title={'Subordinates'} subtitle={'Subordinates details and there attendance summary'} totalRecords={totalRecords} />

            {/* table */}
            <Reactable
                columns={columns}
                data={data}
                setData={setData}
                setTotalCount={setTotalRecords}
                serverSide={true}
                url={SUBORDINATES_URL}
                tableHeight="calc(100vh - 320px)"
                rowSize={"sm"}
                isCSVRequired
                isPDFRequired
            />
        </ContainerCard>
    );
}

export default SubordinatesList;